import { render, staticRenderFns } from "./BuyMarketHistoryDetail.vue?vue&type=template&id=38707903&scoped=true&"
import script from "./BuyMarketHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./BuyMarketHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyMarketHistoryDetail.vue?vue&type=style&index=0&id=38707903&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38707903",
  null
  
)

export default component.exports